import { api } from '@/api/client';

// Interface for generate settlement request
export interface GenerateSettlementRequest {
  merchant_uuid: string;
}

// Interface for generate settlement response
export interface GenerateSettlementResponse {
  success: boolean;
  message: string;
}

// Settlement service
export const settlementService = {
  // Generate settlement for a merchant
  async generateSettlement(data: GenerateSettlementRequest): Promise<GenerateSettlementResponse> {
    const response = await api.post<GenerateSettlementResponse>(
      '/backoffice/api/v1/generate-settlements',
      data
    );
    return response as unknown as GenerateSettlementResponse;
  },
};

